import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import {
    GetRoadmapClientMappingOutputDto,
    UpdateOrgClientLabelInputDto,
    UpdateOrgClientLabelOutputDto,
} from '../../../models/roadmap/dto/roadmap.dto';
import { ROADMAP_CLIENT_MAPPING_QUERY_KEY } from './useGetRoadmapClientMapping';

type Vars = { organizationId: string; linearClientLabelId: string | null };

export const useSetOrgClientLabel = (callbacks?: {
    onSuccess?: () => void;
    onError?: () => void;
}) => {
    const client = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ organizationId, linearClientLabelId }: Vars) =>
            client.fetchApi<UpdateOrgClientLabelOutputDto, UpdateOrgClientLabelInputDto>({
                endpoint: `roadmap/admin/organizations/${encodeURIComponent(
                    organizationId,
                )}/client-label`,
                method: 'POST',
                body: { linearClientLabelId },
            }),
        onSuccess: (data) => {
            // Patch the one changed row from the authoritative response instead
            // of refetching the whole mapping (and re-hitting Linear).
            queryClient.setQueryData<GetRoadmapClientMappingOutputDto>(
                ROADMAP_CLIENT_MAPPING_QUERY_KEY,
                (old) =>
                    old
                        ? {
                              ...old,
                              organizations: old.organizations.map((o) =>
                                  o.id === data.id
                                      ? {
                                            ...o,
                                            linearClientLabelId:
                                                data.linearClientLabelId,
                                        }
                                      : o,
                              ),
                          }
                        : old,
            );
            callbacks?.onSuccess?.();
        },
        onError: () => callbacks?.onError?.(),
    });
};
